// DateInput.js
// Component for Date Text Input

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Label } from '@blueprintjs/core';
import dateFormat from 'dateformat';

// Component Class
// Shows Date Text Input
class DateInput extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      date: dateFormat(new Date(), "dd/mm/yyyy"),
    }
  }

  // Method called when date input changes
  onValueChange = (event) => {
    var date = event.target.value.trim();
    this.props.setDate(date);
  }

  // Renders Component
  render() {
    return (
      <Label inline>
        Entrega:
        <InputGroup 
          placeholder="Digite a data de entrega do pedido"
          value={this.props.date}
          onChange={this.onValueChange}
        />
      </Label>
    );
  }
}

// Required Properties
DateInput.propTypes = {
  date: PropTypes.string,
  setDate: PropTypes.func.isRequired,
}

// Exports
export default DateInput;


// WEBPACK FOOTER //
// ./src/components/ReportView/DateInput.js